export const mapOrder = order => {
  const statuses = sortOrders(order.statuses)

  return {
    ...order,
    status: statuses[0].status,
    statuses
  }
}

const sortOrders = statuses => {
  const statusOrder = [
    'PLACED',
    'UNPROCESSED',
    'CANCELLED',
    'PROCESSED',
    'STARTED',
    'DELIVERED'
  ]

  return statuses.sort((a, b) => {
    const aIndex = statusOrder.indexOf(a.status)
    const bIndex = statusOrder.indexOf(b.status)

    if (aIndex < bIndex) {
      return 1
    }

    if (bIndex < aIndex) {
      return -1
    }

    return 0
  })
}
